<template>
  <div class="charts-2col">
    <div class="nps-card">
      <div class="nps-card-title">Distribución NPS</div>
      <charts :options="donutOptions"></charts>
      <div class="donut-legend">
        <div v-for="item in legendItems" :key="item.label" class="legend-item">
          <span class="legend-dot" :style="{ background: item.color }"></span>
          <span>{{ translateLabel(item.label) }} - {{ item.pct.toFixed(1) }}%</span>
        </div>
      </div>
    </div>
    <div class="nps-card">
      <div class="nps-card-title">Tendencia NPS por día</div>
      <charts :options="trendOptions"></charts>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaDistributionSection',
  props: {
    distribution: {
      type: Array,
      default: function () {
        return [];
      }
    },
    trend: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  computed: {
    legendItems () {
      const total = this.distribution.reduce((sum, item) => sum + Number(item.value || 0), 0);

      return this.distribution.map((item) => ({
        label: item.label,
        color: item.color,
        pct: total > 0 ? (Number(item.value || 0) / total) * 100 : 0
      }));
    },
    donutOptions () {
      return {
        chart: {
          type: 'pie',
          height: 200,
          spacing: [0, 0, 0, 0]
        },
        title: {
          text: null
        },
        plotOptions: {
          pie: {
            innerSize: '65%',
            borderWidth: 0,
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        series: [{
          data: this.distribution.map((item) => ({
            name: item.label,
            y: item.value,
            color: item.color
          }))
        }]
      };
    },
    trendOptions () {
      return {
        chart: {
          type: 'line',
          height: 240,
          spacing: [0, 0, 0, 0]
        },
        title: {
          text: null
        },
        xAxis: {
          categories: this.trend.map((item) => this.formatDate(item.date)),
          gridLineWidth: 0,
          labels: {
            rotation: -45,
            style: {
              color: '#6B7280'
            }
          }
        },
        legend: {
          enabled: true
        },
        credits: {
          enabled: false
        },
        tooltip: {
          shared: true
        },
        plotOptions: {
          line: {
            marker: {
              enabled: false
            },
            lineWidth: 3
          }
        },
        series: [
          {
            name: 'NPS',
            data: this.trend.map((item) => item.nps),
            color: '#E94560'
          },
          {
            name: 'Respuestas',
            data: this.trend.map((item) => item.responses),
            color: '#6366F1',
            yAxis: 1
          }
        ],
        yAxis: [
          {
            title: {
              text: null
            },
            gridLineColor: '#EEF0F5'
          },
          {
            title: {
              text: null
            },
            opposite: true,
            gridLineWidth: 0
          }
        ]
      };
    }
  },
  methods: {
    translateLabel (value) {
      const labels = {
        Promoters: 'Promotores',
        Neutrals: 'Neutros',
        Detractors: 'Detractores'
      };

      return labels[value] || value;
    },
    formatDate (value) {
      if (!value || value.indexOf('-') === -1) {
        return value;
      }

      const parts = value.split('-');
      return `${parts[2]}-${parts[1]}`;
    }
  }
};
</script>

<style scoped>
.charts-2col {
  display: grid;
  gap: 16px;
  grid-template-columns: 340px 1fr;
}

.nps-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  padding: 20px 22px;
}

.nps-card-title {
  color: var(--text-primary, #1A1A2E);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 14px;
}

.donut-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.legend-item {
  align-items: center;
  color: var(--text-primary, #1A1A2E);
  display: flex;
  font-size: 12px;
  gap: 8px;
}

.legend-dot {
  border-radius: 50%;
  flex-shrink: 0;
  height: 12px;
  width: 12px;
}

@media (max-width: 900px) {
  .charts-2col {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/DistributionSection.vue